import IPCService from './inPageConditioningService';

const IPCServiceInstance = new IPCService();

if (process.env.NODE_ENV !== 'production') {
  window.IPCService = IPCServiceInstance;
}

export default IPCServiceInstance;
